<template>
  <!-- prettier-ignore -->
  <index-content>
    <Tabs v-model="tab" name="customerAccess" :animated="false" @on-click="changeTab">
      <template slot="extra">
        <div class="n-button-box">
          <nb-download v-if="tab === 'active'" :url="CUSTOMER_ACCESS_ACTIVE_CSV_URL" :params="activeCondition" />
          <nb-download v-else :url="CUSTOMER_ACCESS_HISTORY_CSV_URL" :params="historyCondition" :disabled="hisCsvDisabled" />
        </div>
      </template>
      <TabPane tab="customerAccess" name="active" :label="this.$t('label.active')" class="pt-2">
        <customer-customer-access-active :condition="activeCondition" @records="changeActiveRecords" />
      </TabPane>
      <TabPane tab="customerAccess" name="history" :label="this.$t('label.history')" class="pt-2">
        <customer-customer-access-history :condition="historyCondition" @records="changeHistoryRecords" @searchedHasError="v => searchedHasError = v" />
      </TabPane>
    </Tabs>
  </index-content>
</template>

<script>
import CustomerView from './view';
import { CUSTOMER_ACCESS_ACTIVE_CSV_URL, CUSTOMER_ACCESS_HISTORY_CSV_URL } from '@/api/customer/customer-customer-access';
import CustomerCustomerAccessActive from './CustomerCustomerAccessActive';
import CustomerCustomerAccessHistory from './CustomerCustomerAccessHistory';
import { isEmpty } from '@/helpers/utils';

export default CustomerView.extend({
  name: 'CustomerCustomerAccess',
  components: { CustomerCustomerAccessActive, CustomerCustomerAccessHistory },
  data() {
    return {
      tab: 'active',
      activeCondition: {
        companyId: 0,
        groupId: 0,
        customerId: null,
        accountId: null,
        sessionId: null,
        from: this.sod,
        to: this.eod,
        isHistory: false,
      },
      historyCondition: {
        companyId: 0,
        groupId: 0,
        customerId: null,
        accountId: null,
        sessionId: null,
        from: this.halfYearAgo,
        to: this.eod,
        isHistory: true,
      },
      activeRecords: [],
      historyRecords: [],
      CUSTOMER_ACCESS_ACTIVE_CSV_URL,
      CUSTOMER_ACCESS_HISTORY_CSV_URL,
      searchedHasError: true,
    };
  },
  computed: {
    hisCsvDisabled() {
      return isEmpty(this.historyCondition.accountId) || this.searchedHasError;
    },
  },
  methods: {
    changeActiveRecords(records) {
      this.activeRecords = records;
      if (this.tab === 'active') this.changeTab('active');
    },
    changeHistoryRecords(records) {
      this.historyRecords = records;
      if (this.tab === 'history') this.changeTab('history');
    },
    changeTab(tab) {
      this.records = tab === 'active' ? this.activeRecords : this.historyRecords;
    },
  },
});
</script>
